module.exports = __webpack_public_path__ + "img/plane2.97249cdc.svg";